/**
 * Events feed module
 */
import Swiper from '../../lib/swiper-core';

const eventsModule = document.querySelectorAll('#events-slider');

eventsModule.forEach(element => {
	new Swiper(element, {
		// Accessibility
		a11y: true,
		keyboard: {
			enabled: true,
		},
		mousewheel: true,
		// Layout 
		spaceBetween: 30, 
		freeMode: true,
		setWrapperSize: true,
		breakpoints: {
			0: {
				slidesPerView: 1
			}, 
			1100: {
				slidesPerView: 2
			}
		},
		// Transition
		direction: 'horizontal',
		speed: 600, 
		// Loop
		loop: false,
		// Navigation
		grabCursor: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			hide: false,
			draggable: true,
		},
		touchEventsTarget: 'wrapper',
		// Events
		on: {
			init: function(swiper) {
				// console.log('events swiper initialized', swiper)
			}
		}
	});
});
